import './navigationBar.scss';
import { useState } from 'react';
import { scrollToElement } from '../../utils';
import RequestQuoteButton from '../request-quote/RequestQuoteButton';

export const NavigationBar = () => {
  const [navItems] = useState([
    { id: '#home', name: 'Home', path: '/' },

    { id: '#services', name: 'Services', path: '/' },
    { id: '#projects', name: 'Projects', path: '/' },
    { id: '#repair-pro-tips', name: 'Repair Tips', path: '/' },
    { id: '#faq', name: "FAQ's", path: '/' },
  ]);
  const [activeNavItem, setActiveNavItem] = useState('#home');

  const handleItemClick = (e: any, id: string) => {
    setActiveNavItem(id);
    setTimeout(() => {
      scrollToElement(id);
    }, 100);
  };

  return (
    <div className="nav-bar">
      <div className="nav-bar__left">
        {navItems.map(({ name, id }) => (
          <div key={name + id} className="nav-bar__left__link" onClick={(e) => handleItemClick(e, id)}>
            {name}
            {id === activeNavItem && <div className="nav-bar__left__link__active"></div>}
          </div>
        ))}
      </div>
    </div>
  );
};
